// extracted by mini-css-extract-plugin
export default {"cards":"Card_cards__HlRZ3","charImgContainer":"Card_charImgContainer__f08Di","charName":"Card_charName__9iuL7"};